module.exports = __webpack_public_path__ + "static/media/sad_face_gray.0c71cb01.svg";